module.exports = __webpack_public_path__ + "static/media/IMG_4268.906b1b2c.PNG";